/**
 * Job title / appraisal level display for analytics tables.
 * Values are translation key identifiers in both live and data-snapshot mode.
 * Snapshot rows resolve keys from historical JobTitleId / AppraisalLevelId; English
 * columns on AnalyticsEmployeeDimensions are often null, and title/level defaults
 * are stable enough that live t() is acceptable (ADR-0006).
 */
export function displayEmployeeDimensionLabel(
  value: string | null | undefined,
  _isSnapshot: boolean,
  translate: (key: string) => string,
): string {
  if (value == null || value === "") {
    return "";
  }
  return translate(value);
}
